/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Importación de módulos y componentes necesarios
import { useState, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import {
  TextField,
  InputAdornment,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Switch,
  Paper,
  Button,
  Select,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Box,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@mui/material';
import { Search as SearchIcon, Add as AddIcon } from '@mui/icons-material';
import Swal from 'sweetalert2';
import {
  getUser,
  addUser,
  deleteUser,
  editUser,
  updateStatus,
  getRol,
  addRol,
  getUserIdWithLatestTimestamp,
  deleteRol,
} from '../../../../api/users';
import { instanceKeycloak } from '../../../../../keycloack';

import useStyles from './styles';
import editarImage from '../../../../images/editar.png';
import eliminarImage from '../../../../images/eliminar.png';
import axios from "axios";

function UsuariosDetalle() {
  const classes = useStyles();

  const [usuarios, setUsuarios] = useState([]); // Inicializar con un array vacío
  const [roles, setRoles] = useState([]); // Inicializar con un array vacío
  const [rolesClient, setRolesClient] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalUsuarioId, SetModalUsuarioId] = useState(null);
  const [modalNombreUsuario, setModalNombreUsuario] = useState('');
  const [modalNombre, setModalNombre] = useState('');
  const [modalApellido, setModalApellido] = useState('');
  const [modalEmail, setModalEmail] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [nombreUsuarioError, setNombreUsuarioError] = useState('');
  const [nombreError, setNombreError] = useState('');
  const [apellidoError, setApellidoError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [selectedRolesError, setSelectedRolesError] = useState('');
  const [selectedRolesClientError, setSelectedRolesClientError] = useState('');
  const [modalStatus, setModalStatus] = useState(true);
  const [usernameDisabled, setUsernameDisabled] = useState(false);
  const [switchValues, setSwitchValues] = useState({});
  const [filteredUsuarios, setFilteredUsuarios] = useState([]); // Nuevo estado para almacenar los resultados filtrados
  const [selectedOption, setSelectedOption] = useState(''); // Estado para almacenar la opción seleccionada en el select
  const [nuevoModalAbierto, setNuevoModalAbierto] = useState(false);
  const [disabledSave, setDisabledSave] = useState(true);
  const [selectedRoles, setSelectedRoles] = useState('');
  const [selectedRolesClient, setSelectedRolesClient] = useState('');
  const [token, setToken] = useState("");
  const urlKeycloak =process.env.REACT_APP_KEYCLOAK
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  // eslint-disable-next-line consistent-return
  const obtenerTokenAdmin = async () => {
    try {
      const response = await axios.post(
        `${urlKeycloak}/realms/master/protocol/openid-connect/token`,
        new URLSearchParams({
          grant_type: 'password',
          client_id: 'admin-cli',
          username: 'admin',
          //dev
          //password: 'admin',
          //prod
          password: 'BestelPUVAdmin2024*',
        }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      // eslint-disable-next-line camelcase
      const { access_token } = response.data;
      // eslint-disable-next-line camelcase
      return access_token;
    } catch (error) {
      console.error('Error al obtener el token de admin:', error.response ? error.response.data : error.message);
    }
  };

  const fetchData = async () => {
    try {
      // Obtiene los usuarios
      const responseUser = await axios.get(
        `${urlKeycloak}/admin/realms/PUV-FRONT/users?briefRepresentation=false`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      // Obtiene la lista de roles
      const responseRol = await axios.get(
        `${urlKeycloak}/admin/realms/PUV-FRONT/roles`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      // Obtiene la lista de roles del cliente
      const responseRolClient = await axios.get(
        `${urlKeycloak}/admin/realms/PUV-FRONT/clients/00d6f432-80fb-47c4-a905-1f41f29568d8/roles`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      // Procesa los datos de los usuarios
      const formattedData = await Promise.all(
        responseUser.data.map(async (user) => {
          try {
            const rolesResponse = await axios.get(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${user.id}/role-mappings/realm`, {
              headers: {
                'Authorization': `Bearer ${token}`,
              }
            });
            const clientRolesResponse = await axios.get(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${user.id}/role-mappings/clients/00d6f432-80fb-47c4-a905-1f41f29568d8`, {
              headers: {
                'Authorization': `Bearer ${token}`,
              }
            });

            const filteredRoles = rolesResponse.data
              .filter(rol => ['NOC', 'Monitoreo', 'Usuario', 'Administrador'].includes(rol.name))
              .map(rol => ({
                id: rol.id,
                name: rol.name,
              }));

            const filteredRolesClient = clientRolesResponse.data
              .filter(rol => ['Autor', 'Usuario'].includes(rol.name))
              .map(rol => ({
                id: rol.id,
                name: rol.name,
              }));
            
            return {
              id: user.id,
              username: user.username,
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email,
              enabled: user.enabled,
              createdTimestamp: user.createdTimestamp ? format(new Date(user.createdTimestamp), 'yyyy/MM/dd') : 'Fecha no disponible',
              roles: filteredRoles,
              rolesRepo: filteredRolesClient
            };
          } catch (error) {
            console.error('Error al obtener roles de usuario:', error);
            return {
              id: user.id,
              username: user.username,
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email,
              enabled: user.enabled,
              createdTimestamp: user.createdTimestamp ? format(new Date(user.createdTimestamp), 'yyyy/MM/dd') : 'Fecha no disponible',
              roles: [],
              rolesRepo: []
            };
          }
        })
      );

      // Filtra los roles del realm y los roles del cliente
      const filterRolesRealm = responseRol.data.filter(rol => ['NOC', 'Monitoreo', 'Usuario', 'Administrador'].includes(rol.name));
      const filterRolesClient = responseRolClient.data.filter(rol => ['Autor', 'Usuario'].includes(rol.name));

      // Actualiza los estados con los roles filtrados
      setRoles(filterRolesRealm);
      setRolesClient(filterRolesClient);

      // Actualiza los usuarios en el estado
      setUsuarios(formattedData);

      // Inicializa los valores de los interruptores basado en los datos de los usuarios
      const initialSwitchValues = {};
      formattedData.forEach((usuario) => {
        initialSwitchValues[usuario.id] = usuario.enabled;
      });
      setSwitchValues(initialSwitchValues);
    } catch (error) {
      console.error('error get directory', error);
    }
  };

  useEffect(() => {
    const loadToken = async () => {
      const tokenAdmin = await obtenerTokenAdmin();
      setToken(tokenAdmin);
    };

    loadToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchDataAndInitializeSwitches = async () => {
      if (token) {
        await fetchData();
      }
    };

    fetchDataAndInitializeSwitches();
  }, [token]);
  
  const isUsernameExists = (username) => {
    return usuarios.some((user) => user.username === username);
  };

  // Maneja el clic en el botón "Agregar Nuevo"
  const handleAgregarClick = () => {
    setIsModalOpen(true);
    SetModalUsuarioId(null);
    setModalNombreUsuario('');
    setModalNombre('');
    setModalApellido('');
    setModalEmail('');
    setModalStatus(true);
    setUsernameDisabled(false);
    setSelectedRoles('');
    setSelectedRolesClient('');
  };

  // Maneja el clic en el botón "Editar"
  const handleEditarClick = async (id, usuario, nombre, apellido, email, enabled, fecha, roles, rolesRepo) => {
    setDisabledSave(true)
    const tokenAdmin = await obtenerTokenAdmin();
    setToken(tokenAdmin);
    setIsModalOpen(true);
    SetModalUsuarioId(id);
    setModalNombreUsuario(usuario);
    setModalNombre(nombre);
    setModalApellido(apellido);
    setModalEmail(email);
    setModalStatus(enabled);
    setUsernameDisabled(true);

    // Obtén los roles del usuario y selecciona sus IDs en el estado selectedRoles
    //const user = usuarios.find((u) => u.id === id);
    const userRoleIds = roles.map(role => role.id);
    const userRoleClientIds = rolesRepo.map((rol) => rol.id);
    setSelectedRoles(userRoleIds[0]);
    setSelectedRolesClient(userRoleClientIds[0]);
    if(usuario !== '' && nombre !== '' && email !== '' && userRoleIds[0] !== '' && userRoleClientIds[0] !== '' && usuario !== undefined && nombre !== undefined && email !== undefined && userRoleIds[0] !== undefined && userRoleClientIds[0] !== undefined && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };

  // Maneja el cambio en el campo "Nombre de Usuario"
  const handleNombreUsuarioChange = (e) => {
    const newUserName = e.target.value;
    setModalNombreUsuario(newUserName);

    if (newUserName.trim().length === 0) {
      setNombreUsuarioError('El usuario no puede estar vacío.');
    } else if (newUserName.trim().length < 3) {
      setNombreUsuarioError('El usuario debe tener al menos 3 caracteres.');
    } else {
      setNombreUsuarioError('');
    }
    
    if(modalNombreUsuario !== '' && modalNombre !== '' && modalEmail !== '' && selectedRoles !== '' && selectedRolesClient!== '' && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };

  // Maneja el cambio en el campo "Nombre"
  const handleNombreChange = (e) => {
    const newName = e.target.value;
    setModalNombre(newName);

    if (modalNombreUsuario.trim().length === 0) {
      if (newName.trim().length > 0 && newName.trim().length < 3) {
        setNombreError('El nombre debe tener al menos 3 caracteres.');
      } else {
        setNombreError('');
      }
    }
    if(modalNombreUsuario !== '' && modalNombre !== '' && modalEmail !== '' && selectedRoles !== '' && selectedRolesClient!== '' && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };

  // Maneja el cambio en el campo "Apellido"
  const handleApellidoChange = (e) => {
    const newApellido = e.target.value;
    setModalApellido(newApellido);

    if (modalNombreUsuario.trim().length === 0) {
      if (newApellido.trim().length > 0 && newApellido.trim().length < 3) {
        setApellidoError('El apellido debe tener al menos 3 caracteres.');
      } else {
        setApellidoError('');
      }
    }
    if(modalNombreUsuario !== '' && modalNombre !== '' && modalEmail !== '' && selectedRoles !== '' && selectedRolesClient!== '' && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };
  
  
  // Maneja el cambio en el campo "Email"
  const handleEmailChange = (e) => {
    // Expresión regular para validar el formato de correo electrónico
    const newEmail = e.target.value;

    if (newEmail.trim().length < 5 || !emailRegex.test(newEmail)) {
      setDisabledSave(true)
      setEmailError('El email no tiene un formato válido.');
    } else {
      setEmailError('');
    }
    setModalEmail(newEmail);
    if(modalNombreUsuario !== '' && modalNombre !== '' && modalEmail !== '' && selectedRoles !== '' && selectedRolesClient!== '' && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };
  // Maneja el cambio en la selección de roles
  const handleSelectChange = (e) => {
    const selectedRolesValue = e.target.value;
    if (selectedRolesValue === '') {
      setSelectedRolesError('Por favor, seleccione al menos un rol.');
    } else {
      setSelectedRolesError('');
    }

    setSelectedRoles(selectedRolesValue);
    if(modalNombreUsuario !== '' && modalNombre !== '' && modalEmail !== '' && selectedRolesClient !== '' && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };

  const handleSelectRolesChange = (e) => {
    const selectedRolesClientValue = e.target.value;

    if (selectedRolesClientValue === '') {
      setSelectedRolesClientError('Por favor, seleccione al menos un rol.');
    } else {
      setSelectedRolesClientError('');
    }
    
    setSelectedRolesClient(selectedRolesClientValue);
    if(modalNombreUsuario !== '' && modalNombre !== '' && modalEmail !== '' && selectedRoles !== '' && emailRegex.test(modalEmail)){
      setDisabledSave(false)
    }
  };

  // Maneja el cambio en el estado de "Estatus"
  const handleStatusChange = async (id, newStatus) => {
    const tokenAdmin = await obtenerTokenAdmin();
    setToken(tokenAdmin);
    
    // Llama a la función para actualizar el estado en Keycloak
    const updatedUserData = {enabled: newStatus};
    await axios.put(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${id}`, updatedUserData,{
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
      .then((updatedUser) => {

        fetchData()

        // Muestra la alerta de SweetAlert
        Swal.fire({
          icon: 'success',
          title: `Usuario ${newStatus ? 'activado' : 'desactivado'} exitosamente`,
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        console.error('Error al actualizar el estado en Keycloak:', error);
        // Maneja cualquier error que pueda ocurrir durante la actualización en Keycloak
      });
  };

  // Maneja el clic en el botón "Guardar"
  const handleGuardarClick = async () => {
    const tokenAdmin = await obtenerTokenAdmin();
    setToken(tokenAdmin);
    let newNombreUsuarioError = '';

    // Realiza la validación específica para el campo de usuario
    if (modalNombreUsuario.trim().length === 0) {
      newNombreUsuarioError = 'El usuario no puede estar vacío.';
    } else if (modalNombreUsuario.trim().length < 3) {
      newNombreUsuarioError = 'El usuario debe tener al menos 3 caracteres.';
    } else if (modalUsuarioId === null && isUsernameExists(modalNombreUsuario)) {
      newNombreUsuarioError = 'El nombre de usuario ya está registrado. Por favor, elija otro.';
    }

    if(selectedRoles === ''){
      setSelectedRolesError('Por favor, seleccione al menos un rol.');
    }


    if(selectedRolesClient  === ''){
      setSelectedRolesClientError('Por favor, seleccione al menos un rol.');
    }
    
    setNombreUsuarioError(newNombreUsuarioError);
    

    // Si no hay errores, guarda la entidad
    if (!newNombreUsuarioError && selectedRolesClientError === '' &&  selectedRolesError === '') {
      if (modalUsuarioId !== null) {
        // Actualizar entidad existente
        const updatedUsuarios = usuarios.map((usuario) =>
          usuario.id === modalUsuarioId
            ? {
              ...usuario,
              username: modalNombreUsuario,
              firstName: modalNombre,
              lastName: modalApellido,
              email: modalEmail,
              enabled: modalStatus,
            }
            : usuario
        );

        setUsuarios(updatedUsuarios);
        
        try {
          const userRolesResponse = await axios.get(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${modalUsuarioId}/role-mappings`, {
            headers: {
              'Authorization': `Bearer ${tokenAdmin}`,
            }
          });
          
          const { data } = userRolesResponse;
          const roleRealm =data?.realmMappings[0].name
          const roleClient =data?.clientMappings?.puv?.mappings[0].name
          
          if(roleRealm && roleRealm !== selectedRoles){
            await axios.delete(
              `${urlKeycloak}/admin/realms/PUV-FRONT/users/${modalUsuarioId}/role-mappings/realm`,
              {
                data: [data?.realmMappings[0]],
                headers: {
                  'Authorization': `Bearer ${tokenAdmin}`,
                }
              }
            );
           
            const rolSel = roles.filter( rol => rol.id === selectedRoles)
            
            await axios.post(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${modalUsuarioId}/role-mappings/realm`, [
                {
                  "id": rolSel[0].id,
                  "name": rolSel[0].name,
                  "composite": true,
                  "clientRole": false,
                  "containerId": "PUV-FRONT"
                }
              ],{
              headers: {
                'Authorization': `Bearer ${tokenAdmin}`,
              }
            });
          }

          if(roleClient && roleClient !== selectedRolesClient){
            await axios.delete(
              `${urlKeycloak}/admin/realms/PUV-FRONT/users/${modalUsuarioId}/role-mappings/clients/00d6f432-80fb-47c4-a905-1f41f29568d8`,
              {
                data: [data?.clientMappings?.puv?.mappings[0]],
                headers: {
                  'Authorization': `Bearer ${tokenAdmin}`,
                }
              }
            );

            const rolSelClient = rolesClient.filter( rol => rol.id === selectedRolesClient)
            
            await axios.post(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${modalUsuarioId}/role-mappings/clients/00d6f432-80fb-47c4-a905-1f41f29568d8`,
              [
                {
                  "id": rolSelClient[0].id,
                  "name": rolSelClient[0].name,
                  "composite": true,
                  "clientRole": true,
                  "containerId": "00d6f432-80fb-47c4-a905-1f41f29568d8"
                }
                ],{
              headers: {
                'Authorization': `Bearer ${tokenAdmin}`,
              }
            });
          }
           
          // Llama a la función editUser para actualizar el usuario
          await axios.put(
            `${urlKeycloak}/admin/realms/PUV-FRONT/users/${modalUsuarioId}`,
            {
              username: modalNombreUsuario,
              firstName: modalNombre,
              lastName: modalApellido,
              email: modalEmail,
              enabled: modalStatus,
            },
            {
              headers: {
                'Authorization': `Bearer ${tokenAdmin}`,
              }
            }
          )
          
          fetchData();

          // Mostrar el mensaje de éxito
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registro actualizado con éxito',
            showConfirmButton: false,
            timer: 1200,
          });

          setIsModalOpen(false); 
          setDisabledSave(true)
        } catch (error) {
          setDisabledSave(true)
          setIsModalOpen(false);
          // Maneja los errores de la actualización del usuario
          console.error('Error al actualizar el usuario:', error);
          // Muestra un mensaje de error al usuario
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al actualizar el usuario',
            text: 'Hubo un problema al actualizar el usuario. Por favor, inténtalo de nuevo más tarde.',
          });
        }
      } else if (!isUsernameExists(modalNombreUsuario)) {
        try {
          await saveRolesAndAddUser(tokenAdmin); // Llama a la función para guardar roles y agregar usuario

          // Cerrar el modal y resetear los campos
          setIsModalOpen(false);
          setNombreUsuarioError(newNombreUsuarioError);
          setNombreError('');
          setApellidoError('');
          setEmailError('');
          setSelectedRolesError('');
          if (modalNombreUsuario.trim().length >= 3) {
            setNombreUsuarioError('');
          }
          setSelectedOption(''); // Puedes establecer el valor inicial según tus necesidades
          // Mostrar el segundo modal para asignar roles
          setNuevoModalAbierto(true);
        } catch (error) {
          setDisabledSave(true)
          // Maneja los errores específicos de saveRolesAndAddUser
          console.error('Error en saveRolesAndAddUser:', error);
        }
      } else {
        // Muestra un mensaje de error si el nombre de usuario ya existe
        newNombreUsuarioError = 'El nombre de usuario ya está registrado. Por favor, elija otro.';
        setNombreUsuarioError(newNombreUsuarioError);
      }
    }
  };
  // Maneja el clic en el botón "Eliminar"
  const handleEliminarClick = async (id) => {
    const tokenAdmin = await obtenerTokenAdmin();
    setToken(tokenAdmin);
    
    const usuario = usuarios.find((u) => u.id === id); // Encuentra el usuario por su ID

    Swal.fire({
      title: `Estás a punto de eliminar al usuario: "${usuario.username}".`,
      text: 'Esta acción no se puede revertir.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Llama a la función deleteUser para eliminar al usuario
          await axios.delete(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${id}`,{
            headers: {
              'Authorization': `Bearer ${token}`,
            }
          })
              .then(() => {
                const updatedUsuarios = usuarios.filter((u) => u.id !== id);
                setUsuarios(updatedUsuarios);

                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Registro eliminado con éxito.',
                  showConfirmButton: false,
                  timer: 1200,
                });
              })
              .catch((error) => console.error('Error al eliminar el usuario:', error));

          
        } catch (error) {
          console.error('Error al eliminar el usuario:', error);
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error al eliminar el usuario',
            text: 'Hubo un problema al eliminar el usuario. Por favor, inténtalo de nuevo más tarde.',
          });
        }
      }
    });
  };

  // Nueva función para guardar roles y agregar usuario
  const saveRolesAndAddUser = async (tokenKey) => {
    try {
      // Guarda los roles seleccionados del estado selectedRoles
      const selectedRolesDetails = roles.filter((rol) => rol.id === selectedRoles);
      const selectedRolesClientDet = rolesClient.filter((rol) => rol.id === selectedRolesClient);

      // Agrega el nuevo usuario
      await axios.post(`${urlKeycloak}/admin/realms/PUV-FRONT/users`,
       {
          username: modalNombreUsuario,
          firstName: modalNombre,
          lastName: modalApellido,
          email: modalEmail,
          enabled: true,
          requiredActions: ["UPDATE_PASSWORD", "CONFIGURE_TOTP"]
        },
        {
          headers: {
            'Authorization': `Bearer ${tokenKey}`,
          }
        }
      )

      const response = await axios.get(`${urlKeycloak}/admin/realms/PUV-FRONT/users?briefRepresentation=false`,{
        headers: {
          'Authorization': `Bearer ${tokenKey}`,
        }
      });
      
      const users = response.data;
      
      // Ordena los usuarios por createdTimestamp de forma descendente
      const sortedUsers = users.sort((a, b) => b.createdTimestamp - a.createdTimestamp);

      // Toma el id del usuario con el createdTimestamp más reciente (el primero en la lista ordenada)
      const userId = sortedUsers[0].id;

      // Actualiza los datos desde Keycloak
      fetchData();

      // Llama a la función addRol para asignar los roles al usuario
      await axios.post(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${userId}/role-mappings/realm`,
        [
          {
            "id": selectedRolesDetails[0].id,
            "name": selectedRolesDetails[0].name,
            "composite": true,
            "clientRole": false,
            "containerId": "PUV-FRONT"
          }
        ],{
        headers: {
          'Authorization': `Bearer ${tokenKey}`,
        }
      });
      
      
      await axios.post(
        `${urlKeycloak}/admin/realms/PUV-FRONT/users/${userId}/role-mappings/clients/00d6f432-80fb-47c4-a905-1f41f29568d8`,
        [
          {
            "id": selectedRolesClientDet[0].id,
            "name": selectedRolesClientDet[0].name,
            "composite": true,
            "clientRole": true,
            "containerId": "00d6f432-80fb-47c4-a905-1f41f29568d8"
          }
          ], {
          headers: {
            'Authorization': `Bearer ${tokenKey}`,
          }
        }
      );

      await axios.put(`${urlKeycloak}/admin/realms/PUV-FRONT/users/${userId}/reset-password`,
        {
          "type": "password", 
          "value": "BestelPUV2024*",
          "temporary": true
        }, {
          headers: {
            'Authorization': `Bearer ${tokenKey}`,
          }
        }
      );
      
      // Muestra el mensaje de éxito
      Swal.fire({
        icon: 'info',
        title: 'Contraseña Temporal',
        text: 'La contraseña temporal para nuevos usuarios es: "BestelPUV2024*"',
        confirmButtonText: 'Ok',
      }).then((result) => {
        if (result.isConfirmed) {
          // Mostrar el segundo SweetAlert
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Registro agregado con éxito',
            showConfirmButton: false,
            timer: 1200,
          });
        }
      });

      setIsModalOpen(false); // Cierra el modal después de la operación exitosa
    } catch (error) {
      // Maneja los errores de la creación del usuario
      console.error('Error al crear el usuario:', error);
      // Muestra un mensaje de error al usuario
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error al crear el usuario',
        text: 'Hubo un problema al crear el usuario. Por favor, inténtalo de nuevo más tarde.',
      });
    }
  };

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    if (searchTerm === undefined) {
      console.error('searchTerm is undefined');
      return;
    }
    setSearchValue(searchTerm);

    // Filtra los datos según el término de búsqueda
    filterUsuarios(searchTerm);
  };
  
  const resetModal = () => {
    SetModalUsuarioId(null);
    setModalNombreUsuario('');
    setModalNombre('');
    setModalApellido('');
    setModalEmail('');
    setModalStatus(true);
    setUsernameDisabled(false);
    setSelectedRoles('');
    setSelectedRolesClient('');
    setIsModalOpen(false)
    setDisabledSave(true)
    setApellidoError('')
    setEmailError('')
    setApellidoError('')
    setNombreError('')
    setNombreUsuarioError('')
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0)
  };

  const paginatedUsuarios = filteredUsuarios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  
  const removeAccents = (str) => {
    return str
      ? str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
      : '';
  };

  const filterUsuarios = useCallback(
    (searchTerm) => {
      if (!searchTerm) {
        // Manejar el caso en que searchTerm sea nulo o indefinido
        setFilteredUsuarios(usuarios);
        return;
      }

      // Normaliza el término de búsqueda y los datos antes de comparar (ignorando mayúsculas/minúsculas)
      const normalizedSearchTerm = removeAccents(searchTerm.toLowerCase());
      const filteredData = usuarios.filter((usuario) => {
        const normalizedUsername = removeAccents((usuario.username || '').toLowerCase());
        const normalizedNombre = removeAccents((usuario.firstName || '').toLowerCase());
        const normalizedApellido = removeAccents((usuario.lastName || '').toLowerCase());
        const normalizedEmail = removeAccents((usuario.email || '').toLowerCase());

        // Comprueba si el término de búsqueda está en cualquiera de los campos
        return (
          normalizedUsername.includes(normalizedSearchTerm) ||
          normalizedNombre.includes(normalizedSearchTerm) ||
          normalizedApellido.includes(normalizedSearchTerm) ||
          normalizedEmail.includes(normalizedSearchTerm)
        );
      });
      setFilteredUsuarios(filteredData);
    },
    [usuarios]
  );

  useEffect(() => {
    // Actualiza los resultados filtrados cuando cambia el estado de usuarios o searchValue
    filterUsuarios(searchValue);
  }, [usuarios, searchValue, filterUsuarios]);

  // Renderiza el componente
  return (
    <div className={classes.root}>
      <h1>Administración de Usuarios</h1>
      <div className={classes.filterAndButton}>
        <TextField
          className={classes.searchField}
          label="Buscar"
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={handleSearchChange} // Manejar cambios en el campo de búsqueda
        />
        <Button variant="contained" color="success" className={classes.addButton} onClick={handleAgregarClick} startIcon={<AddIcon />}>
          Agregar Nuevo
        </Button>
      </div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">Usuario</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Apellido</TableCell>
              <TableCell align="center">Email</TableCell>
              <TableCell align="center">Rol</TableCell>
              <TableCell align="center">Rol Repositorio</TableCell>
              <TableCell align="center">Fecha de Creación</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Eliminar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedUsuarios.length === 0 ? (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No se encontraron resultados.
                </TableCell>
              </TableRow>
            ) : (
              paginatedUsuarios.map((usuario, index) => (
                <TableRow key={usuario.id}>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{usuario.username}</TableCell>
                  <TableCell align="center">{usuario.firstName}</TableCell>
                  <TableCell align="center">{usuario.lastName}</TableCell>
                  <TableCell align="center">{usuario.email}</TableCell>
                  <TableCell align="center">
                    {usuario.roles !== undefined && usuario.roles.length > 0
                      ? usuario.roles.map((rol, roleIndex) => (
                        <span key={rol.id}>
                            {roleIndex > 0 ? ', ' : ''}
                          {rol.name}
                          </span>
                      ))
                      : 'Sin rol asignado'}
                  </TableCell>
                  <TableCell align="center">
                    {usuario.rolesRepo !== undefined && usuario.rolesRepo.length > 0
                      ? usuario.rolesRepo.map((rol, roleIndex) => (
                        <span key={rol.id}>
                            {roleIndex > 0 ? ', ' : ''}
                          {rol.name}
                          </span>
                      ))
                      : 'Sin rol asignado'}
                  </TableCell>
                  <TableCell align="center">{usuario.createdTimestamp}</TableCell>
                  <TableCell align="center">
                    <div className={classes.centeredSwitch}>
                      <Switch
                        checked={switchValues[usuario.id] || false}
                        onChange={() => handleStatusChange(usuario.id, !switchValues[usuario.id])}
                        className={classes.customSwitch}
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={editarImage}
                        alt="Editar"
                        className={`${classes.imageButtonEditar} ${classes.imageButtonWithMargin}`}
                        onClick={() =>
                          handleEditarClick(
                            usuario.id,
                            usuario.username,
                            usuario.firstName,
                            usuario.lastName,
                            usuario.email,
                            usuario.enabled,
                            usuario.createdTimestamp,
                            usuario.roles,
                            usuario.rolesRepo
                          )
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    <div className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}>
                      <img
                        src={eliminarImage}
                        alt="Eliminar"
                        className={`${classes.imageButtonEliminar} ${classes.imageButtonWithMargin}`}
                        onClick={() => handleEliminarClick(usuario.id)} // Llama a handleEliminarClick con el ID del usuario
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredUsuarios.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <Dialog 
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        >
        <DialogContent>
          <h2>{modalUsuarioId !== null ? 'Editar Elemento' : 'Agregar nuevo elemento'}</h2>
          <TextField
            label="Usuario"
            variant="outlined"
            value={modalNombreUsuario}
            onChange={handleNombreUsuarioChange}
            className={classes.modalTextField}
            error={nombreUsuarioError !== ''}
            helperText={nombreUsuarioError}
            disabled={usernameDisabled} // Usa la variable de estado para habilitar o deshabilitar el campo
          />
          <TextField
            label="Nombre"
            variant="outlined"
            value={modalNombre}
            onChange={handleNombreChange}
            className={classes.modalTextField}
            error={nombreError !== ''}
            helperText={nombreError}
          />
          <TextField
            label="Apellido"
            variant="outlined"
            value={modalApellido}
            onChange={handleApellidoChange}
            className={classes.modalTextField}
            error={apellidoError !== ''}
            helperText={apellidoError}
          />
          <TextField
            label="Email"
            variant="outlined"
            value={modalEmail}
            onChange={handleEmailChange}
            className={classes.modalTextField}
            error={emailError !== ''}
            helperText={emailError}
          />
          {roles?.length > 0 && (
          <FormControl variant="outlined" className={classes.modalTextField} error={selectedRolesError !== ''}>
            <InputLabel id="rolLabel">Rol</InputLabel>
            <Select
              labelId="rolLabel"
              id="rolSelect"
              label="Roles"
              multiple={false} 
              value={selectedRoles}
              onChange={handleSelectChange}
              input={<OutlinedInput id="select-multiple-chip" label="Roles" />}
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {/* Comprobar si el valor seleccionado no está vacío */}
                  {selected ? (
                    <Chip label={roles.find((role) => role.id === selected)?.name || 'Rol no encontrado'} />
                  ) : null}
                </Box>
              )}
            >
              {roles.map((rol) => (
                <MenuItem key={rol.id} value={rol.id}>
                  {rol.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{selectedRolesError}</FormHelperText>
          </FormControl>
            )}
          {rolesClient?.length > 0 && (
            <FormControl variant="outlined" className={classes.modalTextField} error={selectedRolesClientError !== ''}>
              <InputLabel id="rolLabel">Rol Repositorio</InputLabel>
              <Select
                labelId="rolLabel"
                id="rolSelect"
                label="Roles"
                multiple={false} 
                value={selectedRolesClient} 
                onChange={handleSelectRolesChange}
                input={<OutlinedInput id="select-multiple-chip" label="Roles" />}
                renderValue={(selected) => (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                    {/* Comprobar si el valor seleccionado no está vacío */}
                    {selected ? (
                      <Chip label={rolesClient.find((role) => role.id === selected)?.name || 'Rol no encontrado'} />
                    ) : null}
                  </Box>
                )}
              >
                {rolesClient.map((rol) => (
                  <MenuItem key={rol.id} value={rol.id}>
                    {rol.name}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{selectedRolesClientError}</FormHelperText>
            </FormControl>
          )}
          <div className={classes.modalButtons}>
            <Button variant="contained"
                    disabled={disabledSave}
                    color="primary" onClick={handleGuardarClick} 
                    className={classes.guardarButton}>
              Guardar
            </Button>
            <Button variant="outlined" color="secondary" onClick={resetModal} className={classes.cancelarButton}>
              Cancelar
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default UsuariosDetalle;